/**
 * Check is value a valid Number
 * @param value
 * @returns {boolean}
 */
export default function isNumeric(value) {
  return !isNaN(value);
}
